module.exports = __webpack_public_path__ + "static/media/refund-banner.d53eec56.png";